/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { lastValueFrom } from 'rxjs';
import { TenantSettingsServiceGetSettingDto, getTenantSettingsService } from '../../../../Services/tenant-settings';

/**
 * Check if a setting with a particular key exists in the specified service.
 */
export const checkForExistingSettingInService = async (dto: TenantSettingsServiceGetSettingDto): Promise<boolean> => {
  // Tenant Settings service
  const tenantSettingsService = getTenantSettingsService();

  return lastValueFrom(tenantSettingsService.getSetting(dto))
    .then(() => true)
    .catch(() => false);
};
